import * as React from 'react';

import { Form, FormActions } from 'components/form';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './profile-boost-intro.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-boost-intro.i18n.json'));

import type { InfluencerProfileForm } from 'types';

interface Props {
  details: InfluencerProfileForm,
  onSubmit: (details: InfluencerProfileForm) => void,
  onCancel: (details: InfluencerProfileForm) => void
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_boost_intro';

const ProfileBoostIntro: React.FC<Props> = ({
  details,
  onSubmit,
  onCancel
}): JSX.Element => {
  const handleSubmit = (): void => (
    onSubmit(details)
  );

  const handleCancel = (): void => (
    onCancel(details)
  );

  const renderActions = (): React.ReactNode => (
    <FormActions align="center">
      <ActionButton
        color="tertiary"
        onClick={handleCancel}
      >
        {__t(`${COMMON_MSG_KEY}.action_button.cancel`)}
      </ActionButton>
      <ActionButton
        color="primary"
        type="submit"
      >
        {__t(`${MSG_KEY}.buttons.boost`)}
      </ActionButton>
    </FormActions>
  );

  return (
    <div className="profile-boost-intro">
      <Form onSubmit={handleSubmit}>
        <div className="profile-boost-intro__heading">
          {__t(`${MSG_KEY}.heading`)}
        </div>
        <div className="profile-boost-intro__description">
          {__t(`${MSG_KEY}.description`)}
        </div>
        <div className="profile-boost-intro__image">
          <img
            src="/static/images/boost-your-profile-intro.png"
            className="lazyload"
            alt="Boost your profile"
          />
        </div>
        {renderActions()}
      </Form>
    </div>
  );
};

export default ProfileBoostIntro;
